import {
	MessageBackend as createMessageBackendJiraProjectSpaceConnected,
	MessageFrontend as createMessageFrontendJiraProjectSpaceConnected,
} from '@post-office/message-template--jira-project-space-connected/placements/in-app-v2/jira-project-space-connected';
import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth-starburst/jira-project-space-connected';


import { withI18n } from './i18n';

const messageBackends = [
	createMessageBackendJiraProjectSpaceConnected({
		messageTemplateId: 'jira-project-space-connected',
	}),
];

const messageFrontends = [
	createMessageFrontendJiraProjectSpaceConnected({
		messageTemplateId: 'jira-project-space-connected',
	}),
];

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
	messageTemplates: messageBackends,
});

export const RawPlacement = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});

export const Placement = withI18n(RawPlacement);

export const SSRPlacement = RawPlacement;

export const middleware = placementBackendFactory(productionRuntime);
